/**
 * Daftar service worker.
 *
 * Hanya di produksi/preview: semasa `vite dev`, service worker akan menyembunyikan HMR dan
 * menyebabkan pepijat yang mengelirukan.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return;

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      // Kegagalan pendaftaran tidak boleh menghalang kasir berjual.
      console.warn('Service worker tidak didaftarkan:', error);
    });
  });
}
